import React, { ReactElement, ReactNode, memo, useState } from 'react';
import { Table, Pagination, ConfigProvider } from 'tea-component';
// import './index.scss';
import { scrollable } from 'tea-component/es/table/addons';
import Loading from '@/pages/intelligence/components/Loading';
import _ from 'lodash-es';
import { useIntl, getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';
const { sortable } = Table.addons;
type IDataList<T = string> = Array<{
  id: T;
  text: T;
  data: T | any;
}>;

interface DropChildProps {
  dataList: IDataList;
  tableData: {
    addonscolumns: Array<string>;
    cvmList: any;
    columns: any;
  };
  children: ReactNode;
  className: string | undefined;
  loading: boolean;
  total: number;
  pageIndex: number;
  pageSize: number;
  onPagingChange: (...args: any) => void;
  OnClickTableSort: (...args: any) => void;
  [key: string]: unknown;
}
const CompaniesTable = memo((props: Partial<DropChildProps>): ReactElement => {
  const {
    tableData,
    className = 'dbi-mobileGames-table dbi-table-sticky',
    loading,
    total = 0,
    pageIndex = 1,
    pageSize = 10,
    OnClickTableSort,
    onPagingChange,
    ...restProps
  } = props;
  const [sorts, setSorts] = useState<any>([]);
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const teaLocale = locale === LANGUAGE_CN ? 'zh' : 'en';
  const buildObject = (arr: string | any[]) => {
    const obj: any = {};
    for (let i = 0; i < arr.length; i++) {
      const { by, order } = arr[i];
      obj[by] = order;
    }
    return obj;
  };

  const handleOnClickTableSortFn = _.debounce((values?: any) => {
    const cloneList = [...values];
    const res = cloneList.map((task, index) => {
      if (index !== 0) {
        task.order = '';
      }
      return {
        by: task.by,
        order: task.order,
      };
    });
    setSorts(cloneList);
    const createObj: { [x: string]: unknown } = buildObject(res);
    // 假设传入的为空，说明用户点击的是同一个升降序都点过，直接参数全部清空，否则，createObj存在并且key值全部不为空，说明和上述同理
    const status = _.isEmpty(cloneList)
      ? true
      : !_.isEmpty(createObj) && Object.keys(createObj).every((task) => !createObj[task]);
    if (status) {
      // debugger
      sorts.forEach((_: any, index: string | number, arr: { [x: string]: { order: string } }) => {
        arr[index].order = '';
      });
    }
    const dataSource = buildObject(status ? sorts : res);
    OnClickTableSort?.(dataSource);
  }, 400);
  const loadingOrNodata = loading || tableData?.cvmList.length === 0;
  return (
    <div style={{ position: 'relative' }}>
      {/* 添加覆盖NoData，不随表格滚动 */}
      <div
        style={{
          display: loadingOrNodata ? 'block' : 'none',
          position: 'absolute',
          // width: '100%',
          width: '-webkit-fill-available',
          zIndex: 9999,
          textAlign: 'center',
          bottom: 122,
        }}
      >
        {loading ? (
          <Loading />
        ) : _.isEmpty(tableData?.cvmList) ? (
          formatMessage({ id: 'common_nodata' })
        ) : (
          ''
        )}
      </div>

      <Table
        className={className}
        bordered="all"
        records={loading ? [] : [...(tableData?.cvmList || [])].sort(sortable.comparer(sorts))}
        columns={tableData?.columns}
        addons={[
          sortable({
            columns: tableData?.addonscolumns || [],
            value: sorts,
            onChange: (e) => handleOnClickTableSortFn(e),
          }),
          scrollable({
            // minWidth: 1400,
            maxHeight: 'calc(100vh - 320px)',
            minHeight: loadingOrNodata ? '158px' : 'auto',
          }),
        ]}
        {...restProps}
      />
      <ConfigProvider locale={teaLocale}>
        <Pagination
          pageSizeOptions={[5, 10, 20, 30, 40, 50]}
          onPagingChange={(e) => {
            if (onPagingChange instanceof Function) {
              onPagingChange(e);
            }
          }}
          pageSize={pageSize}
          pageIndex={pageIndex}
          recordCount={total}
          stateTextVisible={true}
          stateText={formatMessage({ id: 'dbi_pagination_total' }, { total })}
        />
      </ConfigProvider>
    </div>
  );
});

export default CompaniesTable;
